import { inject } from "vue"
import ConfigService from "@shared/helpers/configServices"

export const useReport = () => {
  const httpService = inject("$reportHttpClient") as any

  const getReports = async (): Promise<any> => {
    try {
      const response = await httpService.get(`/Report/Menu?systems=${ConfigService.Current.reportSystemName}`)
      if (response.status === 200) {
        return response.data
      }
      return null
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  return {
    getReports,
  }
}
